// GoEasy 即时通讯连接工具
// 文档：https://www.goeasy.io
// 在这里创建单例实例，main.js 会把它挂载到 Vue.prototype.goeasy 供组件使用，
// 工具内部直接引用本模块的 goEasy 实例，不依赖 Vue.prototype 注册表查找。
import GoEasy from 'goeasy';

// 全局唯一的 GoEasy 实例
export const goEasy = GoEasy.getInstance({
  host: "hangzhou.goeasy.io", // 若是新加坡区域：singapore.goeasy.io
  appkey: "BC-af899252884c4c0fa5bfc41014b289dd",
  modules: ['im'] // 根据需要，传入 'im' 或 'pubsub'，或数组方式同时传入
});

// 登录成功后建立 IM 连接
// user 结构需包含：user_id / id、avatar、nickname 等字段
export function connectGoEasy(user) {
  if (!goEasy) {
    console.error('GoEasy 实例未初始化');
    return;
  }
  if (!user) {
    console.error('connectGoEasy 缺少 user 信息');
    return;
  }
  const user_id = user.user_id || user.aid || user.id || user.mobile;
  if (!user_id) {
    console.error('connectGoEasy 缺少 user_id');
    return;
  }
  goEasy.connect({
    id: String(user_id), // im 必填，最大长度 60 字符
    data: {
      avatar: user.avatar || user.headimg || '',
      nickname: user.nickname || user.user_name || user.mobile || '',
    }, // 必须是一个对象，im 必填，最大长度 300 字符，显示在会话列表中
    onSuccess: function () {
      console.log('GoEasy connect successfully.'); // 连接成功
    },
    onFailed: function (error) {
      console.log('Failed to connect GoEasy, code:' + error.code +
        ',error:' + error.content);
    },
    onProgress: function (attempts) {
      console.log('GoEasy is connecting', attempts);
    },
  });
}

// 断开 GoEasy 连接（退出登录时调用）
export function disconnectGoEasy() {
  if (goEasy) {
    goEasy.disconnect({
      onSuccess: function () {
        console.log('GoEasy disconnect successfully.');
      },
      onFailed: function (error) {
        console.log('Failed to disconnect GoEasy, code:' + error.code + ',error:' + error.content);
      },
    });
  }
}

// 判断当前是否已连接 GoEasy
export function isGoEasyConnected() {
  if (!goEasy) return false
  // 状态值：connected / connecting / disconnected
  return goEasy.getConnectionStatus() === 'connected'
}

// 确保 GoEasy 已连接（用于点击"聊生意"等场景）
// 已连接则不做处理；未连接/断开则重新 connect（GoEasy 自带断线自动重连）
export function ensureGoEasyConnected(user) {
  if (!goEasy) {
    console.error('GoEasy 实例未初始化');
    return Promise.resolve(false)
  }
  // 已连接直接返回
  if (isGoEasyConnected()) {
    return Promise.resolve(true)
  }
  // 未登录（无 user）无法重连
  if (!user) {
    console.error('ensureGoEasyConnected 缺少 user 信息，无法重连');
    return Promise.resolve(false)
  }
  const user_id = user.user_id || user.aid || user.id || user.mobile
  if (!user_id) {
    console.error('ensureGoEasyConnected 缺少 user_id');
    return Promise.resolve(false)
  }
  return new Promise((resolve) => {
    goEasy.connect({
      id: String(user_id),
      data: {
        avatar: user.avatar || user.headimg || '',
        nickname: user.nickname || user.user_name || user.mobile || '',
      },
      onSuccess: function () {
        console.log('GoEasy connect successfully (reconnect).');
        resolve(true)
      },
      onFailed: function (error) {
        console.log('Failed to connect GoEasy, code:' + error.code + ',error:' + error.content);
        resolve(false)
      },
      onProgress: function (attempts) {
        console.log('GoEasy is connecting', attempts);
      },
    })
  })
}
